import React from 'react'
import { Bar } from "react-chartjs-2"
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import moment from 'moment';


ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const options = {
  maintainAspectRatio: false,
  responsive: true,
  plugins: {
    legend: {
      display: false
    },
  },
  scales: {
    x: {
      stacked: true,
      grid: {
        display: false
      },
    },
    y: {
      stacked: true,
      grid: {
        display: false
      },
      ticks: {
        stepSize: 1
      }
    }
  }
}

const labels: string[] = ['Jan', 'Fev', 'Mars', "Avr", 'Mai', 'Jui', 'Juil', 'Aou', 'Sep', 'Oct', 'Nov', 'Dec']

const data = {
  labels,
  datasets: [],
};


const ErrorChart = (props: { errors: any }) => {
  const { errors } = props

  const formatData = (list: any) => {
    const start = moment(new Date(new Date().getFullYear(), 0, 0));
    const end = moment(new Date(new Date().getFullYear(), 11, 31));

    let result: string[] = []

    while (start.add(1, 'months').diff(end) <= 0) {
      result.push(start.clone().format("YYYY-MM"));
    }

    let status = ['wrong sku', 'wrong count', 'other', 'lisibility']
    let obj = {
      'wrong sku': [],
      'wrong count': [],
      'other': [],
      'lisibility': []
    }
    status.forEach((x) => {
      result.forEach((elem) => {
        const found = list?.find((i: { _id: { date: string, status: string } }) => i._id.date === elem && i._id.status === x)
        if (found) {
          obj[x].push(found.count)
        } else {
          obj[x].push(0)
        }
      })
    })

    return {
      labels,
      datasets:
        [
          {
            label: 'SKU ne correspond pas au bracelet',
            data: obj['wrong sku'],
            borderColor: 'rgb(251, 191, 36)',
            backgroundColor: 'rgba(251, 191, 36, 1)',
          },
          {
            label: 'Nombre de bracelet incorrect',
            data: obj['wrong count'],
            borderColor: 'rgb(148, 197, 253)',
            backgroundColor: 'rgba(148, 197, 253, 1)',
          },
          {
            label: 'SKU illisible',
            data: obj.lisibility,
            borderColor: 'rgb(248, 113, 113)',
            backgroundColor: 'rgba(248, 113, 113, 1)',
          },
          {
            label: 'Autres',
            data: obj.other,
            borderColor: 'rgb(168, 168, 168)',
            backgroundColor: 'rgba(168, 168, 168, 1)',
          },
        ]
    }
  }

  return (
    <Bar
      options={options}
      data={!errors ? data : formatData(errors)}
    />
  )
}

export default ErrorChart